(() => {
  const readMoreSelector = '.grp-entangle--root .grp-read-more';
  let dialog;
  let lastTrigger;

  const createDialog = () => {
    const element = document.createElement('dialog');
    element.className = 'entangle-review-modal';
    element.setAttribute('aria-labelledby', 'entangle-review-modal-name');
    element.innerHTML = `
      <div class="entangle-review-modal__panel">
        <button class="entangle-review-modal__close" type="button" aria-label="Close review">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
          </svg>
        </button>
        <h2 class="entangle-review-modal__name" id="entangle-review-modal-name"></h2>
        <p class="entangle-review-modal__date"></p>
        <div class="entangle-review-modal__stars" aria-hidden="true"></div>
        <p class="entangle-review-modal__content"></p>
      </div>
    `;

    element.querySelector('.entangle-review-modal__close').addEventListener('click', () => {
      element.close();
    });

    element.addEventListener('click', (event) => {
      if (event.target === element) {
        element.close();
      }
    });

    element.addEventListener('close', () => {
      lastTrigger?.focus({ preventScroll: true });
      lastTrigger = null;
    });

    document.body.appendChild(element);
    return element;
  };

  const getReviewText = (trigger, card) => {
    const reviewElement = trigger.closest('[data-review]') || card?.querySelector('[data-review]');

    if (reviewElement?.dataset.review) {
      return reviewElement.dataset.review.trim();
    }

    const visibleReview = card?.querySelector('.grp-entangle-item-body-review')?.cloneNode(true);
    visibleReview?.querySelectorAll('.grp-read-more').forEach((element) => element.remove());
    return visibleReview?.textContent.trim() || '';
  };

  const openReview = (trigger) => {
    const card = trigger.closest('.grp-entangle-item');
    const reviewText = getReviewText(trigger, card);

    if (!card || !reviewText) {
      return;
    }

    dialog ||= createDialog();
    lastTrigger = trigger;

    const reviewerName = card.querySelector('.grp-entangle-item-head-name')?.textContent.trim();
    const reviewDate = card.querySelector('.grp-entangle-item-date')?.textContent.trim();
    const stars = card.querySelector('.grp-entangle-rating, .grp-entangle-item-body-stars');
    const nameElement = dialog.querySelector('.entangle-review-modal__name');
    const dateElement = dialog.querySelector('.entangle-review-modal__date');
    const starsElement = dialog.querySelector('.entangle-review-modal__stars');

    nameElement.textContent = reviewerName || 'Customer Review';
    dateElement.textContent = reviewDate || '';
    dateElement.hidden = !reviewDate;
    starsElement.replaceChildren();

    if (stars) {
      starsElement.appendChild(stars.cloneNode(true));
    }

    dialog.querySelector('.entangle-review-modal__content').textContent = reviewText;
    dialog.showModal();
  };

  const handleActivation = (event) => {
    const trigger = event.target.closest?.(readMoreSelector);

    if (!trigger) {
      return;
    }

    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    openReview(trigger);
  };

  document.addEventListener('click', handleActivation, true);
  document.addEventListener('keydown', handleActivation, true);
})();
